/* eslint-disable func-names */
/* eslint-disable no-loop-func */
import './skin-care-quiz';

// load 'deferred' sections on user interaction using Section rendering api
// uses global var deferredCallbacks to do extra processing per section type

(function loadSectionsOnInteraction() {
  const events = ['scroll', 'touchstart'];
  const callbacks = window.deferredCallbacks;

  const loadSection = function (e) {
    const sectionId = e.dataset.id;
    if (!sectionId) return;
    e.classList.remove('deferred-section');
    const parent = e.parentElement;
    if (!parent) return; // already processed/removed
    if (parent.classList.contains('shopify-section')) e = parent;

    const url = `${window.Shopify.routes.root}?view=deferred&section_id=${sectionId}`;
    fetch(url)
      .then((result) => result.text())
      .then((result) => {
        e.insertAdjacentHTML('afterend', result);
        const newE = e.nextElementSibling;
        e.remove();

        const section = newE.querySelector('[data-section-type');
        if (!section) { return; }
        const { sectionType } = section.dataset;
        if (sectionType) {
          const sectionConstructor = window.Shopify.theme.sections.registered[sectionType];
          if (sectionConstructor) {
            const newInstance = {};
            window.Shopify.theme.sections.instances.push(newInstance);
            sectionConstructor.bind(newInstance)(section);
            if (callbacks && callbacks[sectionType]) {
              callbacks[sectionType](section);
            }
          }
        }
      });
  };
  const checkVisibilityAll = function () {
    const deferredSections = document.querySelectorAll('.deferred-section');

    for (let i = 0; i < deferredSections.length; i++) {
      const location = deferredSections[i].getBoundingClientRect();
      if (location.bottom >= 0
        && location.top < window.innerHeight
        && location.right >= 0
        && location.left < window.innerWidth) {
        loadSection(deferredSections[i]);
      }
    }
  };
  const loadSectionsAll = function () {
    const deferredSections = document.querySelectorAll('.deferred-section'); 

    if (document.readyState === 'loading') { return; }

    for (let i = 0; i < deferredSections.length; i++) {
      loadSection(deferredSections[i]);
    }
    events.forEach((event) => window.removeEventListener(event, loadSectionsAll, true));
  };

  events.forEach((event) => window.addEventListener(event, loadSectionsAll, true));
  document.addEventListener('DOMContentLoaded', checkVisibilityAll);
}());
